// handle data rights request (DSR) form events
document.addEventListener('DOMContentLoaded', function () {
  const $dsrForm = document.querySelector('#dsrForm');
  if (!$dsrForm) return;

  const FEED_BACK_MESSAGE_MODAL = 'feedback-message';

  // reusable feedback popup (shares the global feedback-message modal)
  function showFeedback(message) {
    publish(PUB_SUB_EVENTS.xModalOpen, {
      modalName: FEED_BACK_MESSAGE_MODAL,
      contentRender: ($slot) => {
        const $content = $slot.querySelector('.x-footer-modal__feedback-layer');
        const $cancel = $slot.querySelector('.x-footer-modal__operation-cancel');

        $content.innerHTML = `
          <div class="x-footer-modal__feedback-content">
            <p class="x-footer-modal__feedback-text">${message}</p>
          </div>
        `;
        if ($cancel && !$cancel.classList.contains('hidden')) {
          $cancel.classList.add('hidden');
        }
      },
    });
  }

  $dsrForm.addEventListener('submit', async (e) => {
    // prevent default submit
    e.preventDefault();

    // native required-field validation (request type / name / email / country)
    if (!$dsrForm.checkValidity()) {
      $dsrForm.reportValidity();
      return;
    }

    const formData = new FormData($dsrForm);

    // email second-pass validation
    const email = (formData.get('dsr[email]') || '').trim();
    const emailValid = xUtils.validateEmail(email);
    if (!emailValid.isValid) {
      showFeedback(emailValid.message);
      return;
    }

    // field names match the GAS core columns (requestType/firstName/... ),
    // shippingAddress is optional and auto-appended as an extra column
    const payload = {
      requestType: formData.get('dsr[requestType]'),
      firstName: (formData.get('dsr[firstName]') || '').trim(),
      lastName: (formData.get('dsr[lastName]') || '').trim(),
      email,
      country: formData.get('dsr[country]'),
      billingAddress: (formData.get('dsr[billingAddress]') || '').trim(),
      orderNumbers: (formData.get('dsr[orderNumbers]') || '').trim(),
      shippingAddress: (formData.get('dsr[shippingAddress]') || '').trim(),
    };

    xUtils.showLoading();
    fetch('https://dsr.xds.co/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      timeout: 30000,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          const ref = res.requestId ? ` Your reference number is ${res.requestId}.` : '';
          showFeedback(
            `Thanks — we’ve received your request.${ref} We’ll follow up at the email address you provided as required by applicable law.`
          );
          $dsrForm.reset();
        } else {
          showFeedback(res.message || 'Something went wrong, please try again later.');
        }
      })
      .catch((err) => {
        console.error(err);
        showFeedback('Something went wrong, please try again later.');
      })
      .finally(() => {
        xUtils.hideLoading();
      });

    subscribe(PUB_SUB_EVENTS.xModalConfirm, (params) => {
      if (params.modalName === FEED_BACK_MESSAGE_MODAL) {
        params.closeMethod && params.closeMethod();
      }
    });
  });
});
